import cn from "clsx";
import { FC } from "react";
import { Modal } from "@components/ui";
import { EModalType } from "@middleware/types";
import { TitlePage } from "@components/commun";
import { useTranslation } from "next-i18next";
import { FiltersForm } from "./FiltersForm/FiltersForm";
import style from "./ModalFilter.module.scss";

interface Props {
  isOpen: Boolean;
  onClose: () => void;
  toggle: (codes: string[]) => void;
  selectedFilters: Set<string>;
  isOptimum?: boolean;
}
export const ModalFilter: FC<Props> = ({
  isOpen,
  onClose,
  toggle,
  selectedFilters,
  isOptimum,
}) => {
  const { t } = useTranslation();
  const handleToggle = (codes: string[]) => {
    toggle(codes);
    onClose();
  };

  return (
    isOpen === true && (
      <div className={style.modalWrap}>
        <Modal
          className={cn(style.filterModal)}
          onClose={onClose}
          variant={EModalType.FLOTTANT}
        >
          <div className={style.header}>
            <div>
              <TitlePage className={cn("mb0 left", style.left)}>
                <span className="t_text" data-testid="">
                  {t("programs.filterMyMeals")}
                </span>
              </TitlePage>
            </div>
          </div>
          <div className={style.wrapper}>
            <div className={style.content}>
              <FiltersForm
                selectedFilters={selectedFilters}
                toggle={handleToggle}
                isOptimum={isOptimum}
              />
            </div>
          </div>
        </Modal>
      </div>
    )
  );
};
